"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createContextMenu;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _enums = require("../../lib/enums");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createContextMenu(props = {}) {
    const { visible = false, config = {}, onSelect = ()=>{} } = props;
    const menuGroup = new _konva.default.Group({
        visible
    });
    const { position = {
        x: 0,
        y: 0
    } } = config;
    const items = [
        {
            id: null,
            label: "Done"
        },
        {
            id: `marker-${_enums.KonvaShapes.CIRCLE}`,
            label: "Point"
        },
        {
            id: `marker-${_enums.KonvaShapes.LINE}`,
            label: "Line"
        },
        {
            id: `marker-${_enums.KonvaShapes.RECTANGLE}`,
            label: "Box"
        },
        {
            id: `marker-${_enums.KonvaShapes.ELLIPSE}`,
            label: "Ellipse"
        }
    ];
    const isHovering = (index = 0)=>{
        menuGroup.getChildren().forEach((child)=>{
            if (child instanceof _konva.default.Group) {
                const groupIndex = child.attrs.index;
                const rect = child.findOne("Rect");
                const text = child.findOne("Text");
                const rectFill = groupIndex === index ? "#999" : "transparent";
                const textFill = groupIndex === index ? "#fff" : "#333";
                rect.fill(rectFill);
                text.fill(textFill);
                child.draw();
            }
        });
    };
    const menu = new _konva.default.Rect({
        name: "menu-container",
        x: position.x,
        y: position.y,
        width: 150,
        height: items.length * 30 + 10,
        fill: "#f0f0f0",
        cornerRadius: 5
    });
    menuGroup.add(menu);
    items.forEach(({ id, label }, index)=>{
        const groupItem = new _konva.default.Group({
            index
        });
        const menuItem = new _konva.default.Rect({
            index,
            x: position.x,
            y: position.y + index * 30 + 10,
            width: 150,
            height: 30,
            fill: "transparent"
        });
        const labelItem = new _konva.default.Text({
            index,
            x: position.x + 10,
            y: position.y + index * 30 + 10 + (30 - 16) / 2,
            text: label,
            fontSize: 16,
            fill: "#333"
        });
        groupItem.on("mouseenter", ()=>isHovering(index));
        groupItem.on("mouseleave", ()=>isHovering(null));
        groupItem.on("mousedown", ()=>onSelect(id));
        groupItem.add(menuItem);
        groupItem.add(labelItem);
        menuGroup.add(groupItem);
    });
    return menuGroup;
}
